module.exports = __webpack_public_path__ + "static/media/vscode.fb3c761f.svg";